import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { Doughnut } from 'react-chartjs-2';
import 'chart.piecelabel.js';

import { LinearProgress, Typography, Paper } from '@material-ui/core';
import { ChartLegendOptions } from 'chart.js';
import { Percentual } from '../../../../services';
import { ResponsiveContainer } from 'recharts';
import { QueryFilter, QUERY_FILTER_PUBLISHER } from 'src/component/shared';
import { GetCacheIfExists, SetDataToSession, HasNoFilterAppliedPublisherShare } from '../../../shared/cache/Cache';

// tslint:disable-next-line:no-empty-interface
export interface IPublisherRegionShareProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IPublisherRegionShareState {
    customFilter: {
        isChart: boolean
    },

}

const COLORS = ['#FF6A14','#323232','#20B2AA', '#FF8042', '#FFBB28', '#90EE90',
    '#FFB6C1', '#FFA07A', '#0088FE', '#87CEFA', '#778899', '#778899', '#B0C4DE',
    '#008080', '#D8BFD8', '#FF6347', '#40E0D0', '#EE82EE', '#00C49F',
    '#C3F500', '#FFBF00', '#84EA00', '#E768B0', '#33CECE', '#062671', '#422D86',
    '#5DCFCA', '#B62E40', '#FF7600', '#F2B5B8'];

const PUBLISHER_SHARE_REGION = gql`
query publisherRegionShare($customFilter:  PublisherCustomFilter) {
    publisherRegionShare(publisherCustomFilter: $customFilter) {
        uf,
		participacao
  }
}
`;

const legenda: ChartLegendOptions = {};
legenda.position = "left";

const getLabel = (tooltipItems: any, data: any) => {
    return ['UF: ' + data.labels[tooltipItems.index],
    'Share:    ' + Percentual(data.datasets[0].data[tooltipItems.index].toString())];
}

const opts: any = {};
opts.tooltips = { displayColors: false, callbacks: { label: getLabel } };
opts.pieceLabel = {
    fontColor: '#555555',
    position: 'outside',
    render: (args: any) => {
        return Percentual(args.value.toString());
    }
}

export interface IPublisherRegionShareDataChart {
    uf: string;
    participacao: number;
}

const PublisherRegionShareChart = ({ data }: { data: Chart.ChartData }) => (
    <ResponsiveContainer width="100%" height={350}>
        <Doughnut key="value" data={data} legend={legenda} options={opts} />
    </ResponsiveContainer>
);

const dataFilled = (data: any) => {
    return data && data.publisherRegionShare && !!data.publisherRegionShare.length
}

export class PublisherRegionShare extends React.Component<IPublisherRegionShareProps, IPublisherRegionShareState> {
    constructor(props: IPublisherRegionShareProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
        }
    }

    public render() {
        const jsonFilter = {
            "customFilter": {
                "isChart": this.state.customFilter.isChart,
            }
        };

        return (
            <Query query={QUERY_FILTER_PUBLISHER} notifyOnNetworkStatusChange={true}  >
                {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {

                    let dataCache = GetCacheIfExists('publisher-data');
                    const hasNoFilterAppliedPublisher = HasNoFilterAppliedPublisherShare(clientC);

                    if( hasNoFilterAppliedPublisher && dataCache != null && dataCache.publisherRegionShare != null ) {
                        return this.dataToRend(dataCache, false);
                    } else {
                        return (
                            <Query query={PUBLISHER_SHARE_REGION} variables={QueryFilter.getFilterPublisher(clientC, jsonFilter, [])}>
                                {({ loading, error, data, client }) => {

                                    if ( hasNoFilterAppliedPublisher && data != null && data.publisherRegionShare != null ) {
                                        if(dataCache != null && dataCache !== undefined) {
                                            dataCache.publisherRegionShare = data.publisherRegionShare;
                                        } else {
                                            dataCache = data;
                                        }
                                        SetDataToSession('publisher-data', dataCache);
                                    }

                                    return this.dataToRend(data, loading);
                                }}
                            </Query>
                        );
                    }
                }}
            </Query>
        )
    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private dataToRend (data:any, loading:any) {
        return (
            <Paper className="publisher-sale-block panel-block" >
                <Typography variant="headline" className="panel-title" component="title">
                    Share por Região
                </Typography>
                {
                    loading
                    ?
                    <LinearProgress />
                    :
                    (
                        dataFilled(data)
                        ?
                        (<PublisherRegionShareChart data={this.PublisherRegionShareMap(data.publisherRegionShare)} />)
                        :
                        (<Typography variant="body2" className="comparative" component="p">
                            Não há informações de vendas
                        </Typography>)
                    )
                }
            </Paper>
        )
    }

    private PublisherRegionShareMap = (data: IPublisherRegionShareDataChart[]) => {

        const mappedData: Chart.ChartData = {};
        const labels: string[] = [];
        const values: any[] = [];
        const datasetss: any = {};

        data.forEach(e => {

            const item: IPublisherRegionShareDataChart = {
                participacao: e.participacao,
                uf: e.uf,
            };

            labels.push(item.uf);
            values.push(item.participacao);
        });
        opts.title = {
            display: true,
            text: ' '
        }
        datasetss.data = values;
        datasetss.backgroundColor = COLORS;
        mappedData.datasets = [datasetss];
        mappedData.labels = labels;

        return mappedData;
    }

}



// WEBPACK FOOTER //
// ./src/component/publisher/sale/region-share/PublisherRegionShare.tsx